module.exports = __webpack_public_path__ + "static/media/agent-giving-keys.765700a8.jpg";